<template>
  <div class="products-stats">
    <div class="products-stats__users">
      <span class="products-stats__users-number">{{ usersOnline }}</span>
      <span class="products-stats__users-text" v-html="usersTranslation"></span>
    </div>
    <div class="products-stats__products">
      <span class="products-stats__products-title">{{ $t('bf_page_stats_products_left') }}</span>
      <div class="products-stats__products-line-wrap">
        <div class="products-stats__products-line">
          <div class="products-stats__products-line-fill" :style="{'width': computedProductsPercent + '%'}"></div>
        </div>
        <span class="products-stats__products-line-percents">{{ computedProductsPercent + '%' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { wordFormatter } from '@/mixins/wordFormatter'
import CurrencyFormatter from '@/filters/CurrencyFormatter'

export default {
  name: 'ProductsStats',
  mixins: [wordFormatter],
  filters: {
    CurrencyFormatter
  },
  props: {
    dateOfStart: {
      type: String,
      required: true
    },
    dateOfNow: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedDateOfStart () {
      return new Date(this.dateOfStart)
    },
    computedDateOfNow () {
      return this.dateOfNow ? new Date(this.dateOfNow) : new Date()
    },
    productsPercent () {
      return Math.round((100 - this.$t('stats_products_day') * ((this.computedDateOfNow - this.computedDateOfStart) / 86400000) * 100 / this.$t('stats_products_total')))
    },
    computedProductsPercent () {
      return this.productsPercent < 100 ? this.productsPercent : 100
    },
    usersOnline () {
      return window.config.total_users_online
    },
    usersTranslation () {
      return this.wordFormatter(this.usersOnline, [this.$t('bf_page_stats_1'), this.$t('bf_page_stats_2'), this.$t('bf_page_stats_3')])
    }
  }
}
</script>

<style scoped lang="sass">
.products-stats
  position: relative
  background: #1A1B1D
  border-radius: 10px
  padding: 25px

  display: flex
  flex-flow: column

  +mmin($tablet)
    padding: 30px
    flex-flow: row nowrap
    justify-content: space-around

  &:before
    content: ''
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-image: url('/img/black-friday/shum.png')
    background-size: 120px 120px
    background-repeat: repeat
    pointer-events: none
    mix-blend-mode: screen

.products-stats__users
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  margin-bottom: 25px

  +mmin($tablet)
    width: 20%
    margin-bottom: 0

.products-stats__users-number
  color: #fff
  font-size: 36px

  +mmin($tablet)
    font-size: 44px

.products-stats__users-text
  color: #fff
  font-size: 14px
  margin-left: 15px

  +mmin($tablet)
    margin-left: 20px

.products-stats__products
  width: 100%
  display: flex
  flex-flow: column
  justify-content: center
  align-items: center

  +mmin($tablet)
    width: 60%

.products-stats__products-title
  display: inline-block
  color: #fff
  font-size: 14px
  margin-bottom: 15px

  +mmin($tablet)
    font-size: 16px

.products-stats__products-line
  position: relative
  height: 6px
  width: 100%
  max-width: 600px
  border-radius: 9px
  background: rgba(255, 255, 255, .2)

.products-stats__products-line-fill
  position: absolute
  height: 100%
  left: 0
  top: 0
  background: #49D34F
  box-shadow: 0 0 20px rgba(73, 211, 79, 0.5)
  border-radius: 9px

.products-stats__products-line-wrap
  width: 100%
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center

.products-stats__products-line-percents
  color: #fff
  font-size: 18px
  margin-left: 25px
</style>
